import { render, staticRenderFns } from "./english-small-training-questions-results.vue?vue&type=template&id=c82267d4&scoped=true&"
import script from "./english-small-training-questions-results.vue?vue&type=script&lang=js&"
export * from "./english-small-training-questions-results.vue?vue&type=script&lang=js&"
import style0 from "./english-small-training-questions-results.vue?vue&type=style&index=0&id=c82267d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82267d4",
  null
  
)

export default component.exports